import apiClient from 'services/axios'
import routeNames from 'routeNames/backendRouteNames'

export default class UsersService {
  constructor() {
    this.apiClient = apiClient
    this.routeNames = routeNames
  }

  getOrganizations = async () => {
    return this.apiClient.get(this.routeNames.Get_ORGANIZATIONS.path)
  }

  getUsers = async ({ params }) => {
    return this.apiClient.get(this.routeNames.GET_USERS.path, {
      params,
    })
  }

  getUser = async ({ id }) => {
    let route = this.routeNames.GET_USER.path
    route = route.replace(':id', id)
    return this.apiClient.get(route)
  }

  updateUser = async ({ body, id }) => {
    let route = this.routeNames.UPDATE_USER.path
    route = route.replace(':userId', id)
    return this.apiClient.patch(route, body)
  }

  getDevelopers = async ({ params }) => {
    return this.apiClient.get(this.routeNames.GET_DEVELOPERS.path, { params })
  }

  getDevops = async ({ params }) => {
    return this.apiClient.get(this.routeNames.GET_DEVOPS.path, { params })
  }
}
